import { render, staticRenderFns } from "./BatchIndex.vue?vue&type=template&id=5202c864&scoped=true&"
import script from "./BatchIndex.vue?vue&type=script&lang=ts&"
export * from "./BatchIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5202c864",
  null
  
)

export default component.exports